import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment.prod';
import { NominationCreationDto } from '@models/votes/nomination-creation.dto';
import { NominationProposalDto } from '@models/votes/nomination-proposal.dto';

@Injectable({
  providedIn: 'root',
})
export class NominationService {
  constructor(private http: HttpClient) {}

  getNominationProposalList() {
    return this.http.get<NominationProposalDto[]>(
      environment.host + '/nomination/list',
    );
  }

  getAvailableProposalList() {
    return this.http.get<NominationProposalDto[]>(
      environment.host + '/nomination/list-available',
    );
  }

  createNomination(creationDto: NominationCreationDto) {
    return this.http.post(environment.host + '/nomination/create', creationDto);
  }

  modifyNomination(nominations: NominationProposalDto[]) {
    return this.http.post(environment.host + '/nomination/modify', nominations);
  }

  removeNomination(nominations: NominationProposalDto[]) {
    return this.http.post(environment.host + '/nomination/remove', nominations);
  }

  submitNomination(proposalId: number) {
    return this.http.get(environment.host + '/nomination/submit/' + proposalId);
  }

  acceptNomination(proposalId: number, userId: number) {
    return this.http.get(
      environment.host +
        '/nomination/accept/' +
        proposalId +
        '?userId=' +
        userId,
    );
  }

  rejectNomination(proposalId: number, userId: number) {
    return this.http.get(
      environment.host +
        '/nomination/reject/' +
        proposalId +
        '?userId=' +
        userId,
    );
  }

  cancelNomination(proposalId: number, userId: number) {
    return this.http.get(
      environment.host +
        '/nomination/cancel/' +
        proposalId +
        '?userId=' +
        userId,
    );
  }
}
